<template>
  <div v-if="isOpen && showBars" class="c-thumbnails-tablet">
    <simplebar
      data-simplebar-auto-hide="false"
      data-simplebar-force-visible="true"
      class="c-thumbnails-tablet__scroll"
    >
      <div
        class="c-thumbnails-tablet__wrapper"
        :class="
          bookRender.twoPages ? 'c-thumbnails-tablet__wrapper--pairs' : ''
        "
        ref="thumbnails"
      >
        <button
          v-for="page in book.content"
          :key="getPageByIndex(page.position)"
          class="c-thumbnails-tablet__item"
          :class="bookRender.twoPages ? 'c-thumbnails-tablet__item--pair' : ''"
          @click.prevent="
            bookRender.getPage(getPageByIndex(page.position))
            $emit('close-thumbnails')
          "
          :aria-label="
            `${$t('GO_TO')} ${$t('PAGE')} ${getPageByIndex(page.position)}`
          "
          :aria-current="
            isSelected(getPageByIndex(page.position)) ? 'true' : 'false'
          "
        >
          <div class="c-thumbnails-tablet__image-container">
            <star-thumbnail-icon
              class="c-thumbnails-tablet__star"
              v-if="checkBookmark(getPageByIndex(page.position))"
            />
            <img
              class="c-thumbnails-tablet__image"
              :src="
                `${$root.$config.booksync_url}/pubs/${
                  book._id
                }/thumbnail/${getPageName(
                  page.name,
                )}.png?token=${encodeURIComponent(accessToken)}`
              "
              :alt="`${$t('PAGE')} ${getPageByIndex(page.position)}`"
              :class="
                isSelected(getPageByIndex(page.position)) ? 'current' : ''
              "
            />
            <div class="c-thumbnails-tablet__shadow"></div>
          </div>
          <span class="c-thumbnails-tablet__label">
            {{ getPageByIndex(page.position) }}</span
          >
        </button>
      </div>
    </simplebar>
  </div>
</template>

<script>
import StarThumbnailIcon from '@/assets/svg/StarThumbnailIcon'
import Simplebar from 'simplebar-vue'
import { mapState } from 'vuex'

import { getPageByIndex, getPageName } from '@/utils/utils'

export default {
  name: 'BookThumbnailsTablet',

  props: {
    isOpen: Boolean,
    showBars: Boolean,
    book: Object,
    bookRender: Object,
    accessToken: String,
  },

  computed: {
    ...mapState('bookmarks', {
      bookmarks: state => state.bookmarks,
    }),
  },

  components: {
    'star-thumbnail-icon': StarThumbnailIcon,
    simplebar: Simplebar,
  },

  methods: {
    getPageByIndex,
    getPageName,
    isSelected(page) {
      let current = this.bookRender.currentPageNumber
      if (
        page === current ||
        (this.bookRender.twoPages && page === current + 1 && current !== 1)
      ) {
        return true
      }
      return false
    },

    checkBookmark(currentPage) {
      if (this.bookmarks) {
        for (let bookmark of this.bookmarks) {
          if (bookmark.page === currentPage) {
            return true
          }
        }
        return false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

.c-thumbnails-tablet {
  position: fixed;
  z-index: 999;
  background: linear-gradient(to bottom, $white, $modal-bottom);
  left: 0;
  right: 0;
  bottom: 0;
  top: 64px;
  transition: all 0.5s;
  margin-bottom: 40px;
}

.c-thumbnails-tablet__scroll {
  height: 100%;
}

.c-thumbnails-tablet__wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 2em;
}

.c-thumbnails-tablet__item {
  @include btnReset();
  margin: 0 1.75em 3.7em 1.75em;
  width: 116px;
  height: 164px;
  cursor: pointer;
  @include a11yOutline();
}

.c-thumbnails-tablet__image-container {
  position: relative;
}

.c-thumbnails-tablet__image {
  display: block;
}

.c-thumbnails-tablet__item--pair:first-child {
  margin: 0 1.75em 3.7em 1.75em;
  width: 232px;
  text-align: left;

  .c-thumbnails-tablet__image {
    width: 116px;
  }

  .c-thumbnails-tablet__label {
    display: block;
    margin-left: calc(25% - 5px);
  }
}

.c-thumbnails-tablet__item--pair:last-child:not(:nth-child(odd)) {
  margin: 0 1.75em 3.7em 1.75em;
  width: 232px;
  text-align: left;

  .c-thumbnails-tablet__image {
    width: 116px;
  }

  .c-thumbnails-tablet__label {
    display: block;
    margin-left: calc(25% - 10px);
  }
}

.c-thumbnails-tablet__item--pair:nth-child(odd):not(:first-child) {
  margin: 0 1.75em 3.7em -1.75em;
}

.c-thumbnails-tablet__item--pair:nth-child(odd):not(:first-child)
  .c-thumbnails-tablet__image {
  border-left: none !important;
}

.c-thumbnails-tablet__item--pair:nth-child(even):not(:first-child):not(:last-child)
  .c-thumbnails-tablet__image {
  border-right: none !important;
}

.current.c-thumbnails-tablet__image {
  border: 3px solid $orange;
}

.c-thumbnails-tablet__label {
  color: $blue;
  font-weight: bold;
  margin-top: 0.6em;
}

.c-thumbnails-tablet__star {
  position: absolute;
  top: -16px;
  right: 0;
}

.c-thumbnails-tablet__item--pair:first-child .c-thumbnails-tablet__star,
.c-thumbnails-tablet__item--pair:nth-child(even) .c-thumbnails-tablet__star {
  right: 50%;
}

.c-thumbnails-tablet__item--pair:nth-child(odd):not(:first-child):not(:last-child) {
  .c-thumbnails-tablet__star {
    right: 0;
  }
}

.c-thumbnails-tablet__item--pair:nth-child(even):not(:first-child):not(:last-child) {
  .c-thumbnails-tablet__star {
    left: 0;
  }
  .c-thumbnails-tablet__shadow {
    box-shadow: inset -5px 0px 8px -6px $dark-grey;
  }
}

.c-thumbnails-tablet__shadow {
  position: absolute;
  width: 116px;
  height: 100%;
  box-shadow: inset 5px 0px 8px -6px $dark-grey;
  top: 0;
  left: 0;
}

@media (min-width: 943px) and (max-width: 1365px) {
  .c-thumbnails-tablet__wrapper--pairs {
    width: 928px;
    margin: auto;
  }
}

@media (min-width: 655px) and (max-width: 942px) {
  .c-thumbnails-tablet__wrapper--pairs {
    width: 640px;
    margin: auto;
  }
}

@media (max-width: 654px) {
  .c-thumbnails-tablet__wrapper--pairs {
    width: 311px;
    margin: auto;
  }
  .c-thumbnails-tablet__item--pair {
    margin-left: 0;
  }
  .c-thumbnails-tablet__item--pair:first-child,
  .c-thumbnails-tablet__item--pair:last-child {
    margin: 0 0 3.7em 0 !important;
  }
  .c-thumbnails-tablet__item--pair:nth-child(odd):not(:first-child) {
    margin: 0 0 3.7em -1.75em;
  }
}
</style>
